import React, { useEffect, useState } from 'react';
import setting from '../../../config.json';
import TauriDatePickerPlanning from './TauriDatePickerPlanning/TauriDatePickerPlanning';
import TauriSidebarFilterPlanning from './TauriSidebarFilterPlanning/TauriSidebarFilterPlanning';
import TauriLoader2 from '../../TauriLoader2/TauriLoader2';
import './PlanningSidebar.css';
import { getAll } from '../../../localDB';
import OpalAccordionItem from '../../OpalAccordionItem/OpalAccordionItem';

const PlanningSidebar = ({ selectedItem }) => {

    const [itemList, setItemList] = useState([]);
    const [search, setSearch] = useState('');
    const [orderby, setOrderBy] = useState(null);
    const [loading, setLoading] = useState(false);
    const [date, setDate] = useState('');
    const [cyclePeriod, setCyclePeriod] = useState('');
    const [totalValue, setTotalValue] = useState(0);
    const [currentValue, setCurrentValue] = useState(0);

    const [selectedCard, setSelectedCard] = useState(null);

    const getTodayWithTimezoneOffset = () => {
        const now = new Date();
        now.setHours(0, 0, 0, 0); // Ensuring time does not affect date selection
        return now;
    };

    const fetchData = async (search, orderby) => {
        try {
            const customerList = await getAll("customer");
            const institutionList = await getAll("institution");

            const mergedList = customerList.map(customer => {
                return {
                    ...customer,
                    Customer: customer
                };
            });

            const data = mergedList.map(customer => {
                const institution = institutionList.find(inst => inst.ID === customer.InstitutionID);
                return {
                    ...customer,
                    institution: institution ? institution.Name : null
                };
            });

            const total = data.reduce((sum, item) => sum + item.Frequency_count, 0);
            setTotalValue(total);

            const lowercasedValue = search.toLowerCase();
            const filtered = data.filter(
                (item) =>
                    item?.Name?.toLowerCase().includes(lowercasedValue) ||
                    item?.AddressDetail?.toLowerCase().includes(lowercasedValue)
            );
            setItemList(filtered);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        const currentDate = getTodayWithTimezoneOffset().toLocaleDateString("en-CA");
        setDate(currentDate);

        if (!currentDate) return;

        const d = new Date(currentDate);
        if (isNaN(d)) return;

        const month = d.getMonth() + 1;

        setCyclePeriod("CP" + month);

    }, []);

    useEffect(() => {
        fetchData(search, orderby)
    }, [search, orderby]);

    const handleDateChanged = (value) => {

        if (!value) return;

        const date = new Date(value);
        if (isNaN(date)) return;

        const month = date.getMonth() + 1;
        setCyclePeriod("CP" + month);
        fetchData(search, orderby)
    };

    const onSelectItem = (item) => {

    }

    return (
        <div className='planning-sidebar'>
            <TauriDatePickerPlanning onDateChange={handleDateChanged} cyclePeriod={cyclePeriod} currentValue={currentValue} maxValue={totalValue} />
            <TauriSidebarFilterPlanning />

            {loading ? (
                <TauriLoader2 width="2.5rem" height="2.5rem" borderwidth="0.35rem" color="#1D5D9B" />
            ) : (
                <OpalAccordionItem
                    items={itemList}
                    search={search}
                    onSelectItem={onSelectItem}
                    type={"v2"}
                    selectedCard={selectedCard}
                    setSelectedCard={setSelectedCard}
                    groupby={false}
                />
            )}
        </div>
    );
};

export default PlanningSidebar;
